function showSection(sectionId, clickedSpan) {
  // Hide all sections
  const sections = document.querySelectorAll(".investor-content-section > div");
  sections.forEach((section) => (section.style.display = "none"));

  // Show the selected section
  const sectionToShow = document.getElementById(sectionId);
  if (sectionToShow) {
    sectionToShow.style.display = "block";
  }

  // Remove active class from all spans
  const navItems = document.querySelectorAll(".investor-nav span");
  navItems.forEach((item) => item.classList.remove("active-investor-nav"));

  // Add active class to the clicked span
  if (clickedSpan) {
    clickedSpan.classList.add("active-investor-nav");
  }
  const dropdown = document.querySelector(".investor-select-dropdown");
  if (
    ["presentation", "financial", "press-release", "announcement"].includes(
      sectionId
    )
  ) {
    dropdown.style.display = "flex";
  } else {
    dropdown.style.display = "none";
  }
}
function toggleSubSection(sectionId) {
  // Get all sections
  const sections = document.querySelectorAll(".subsection");
  const subSectionToToggle = document.getElementById(sectionId);

  // Check if the section to toggle is currently displayed
  if (subSectionToToggle.style.display === "block") {
    // Hide the section if it's currently displayed
    subSectionToToggle.style.display = "none";
  } else {
    // Hide all sections
    sections.forEach((section) => (section.style.display = "none"));
    // Show the selected section
    subSectionToToggle.style.display = "block";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const selectElement = document.getElementById("fiscal-year-select");
  const tabContents = document.querySelectorAll(".tab-content");

  function updateVisibility() {
    const selectedValue = selectElement?.value;

    tabContents.forEach((content) => {
      if (content.getAttribute("data-fiscal-year") === selectedValue) {
        content.style.display = "grid";
      } else if (content.getAttribute("data-fiscal-year") === "") {
        content.style.display = "grid";
      } else {
        content.style.display = "none";
      }
    });
  }

  // Initial check on page load
  updateVisibility();

  // Update visibility when the selection changes
  selectElement?.addEventListener("change", updateVisibility);
});
